<template>
  <div
    v-if="devmode"
  >
    <div
  
      class="sticky"
    >
      This server is in development mode
    </div>
  </div>
</template>
<script>
import { mount } from '@vue/test-utils'
export default {
  name: 'Sticky',
  data() {
      return {
        devmode: null
      }
  },
    mounted() {
             if(process.env.NODE_ENV === 'development') {this.devmode = true}
  },
}
</script>
